var _path, _polyline, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidateSummaryDisable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    stroke: "#9ca3af",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.5,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 8,
    y2: 13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17,
    x2: 8,
    y2: 17
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 8,
    y2: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateSummaryDisable);
export default __webpack_public_path__ + "static/media/candidate-summary_disable.e3a54339fe28821d42e01e53512b8c84.svg";
export { ForwardRef as ReactComponent };